import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../../common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import { MdrtStampIconDetail, MdrtStampIconFormMode } from '../../../types/mdrt-stamp-icon-types';
import { fetchItem } from '../../../network/mdrtStampIconCrud';
import MdrtStampIconDetailForm from './components/MdrtStampIconDetailForm';

interface StateMdrtType {
  type: MdrtStampIconFormMode;
}

const MdrtStampIconDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, itemId } = useMemo(() => {
    const state = location.state as StateMdrtType;
    return {
      formMode: state.type,
      itemId: id ? id : undefined,
    };
  }, [id, location]);

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [itemDetail, setItemDetail] = useState<MdrtStampIconDetail>();

  const reloadData = () => {
    if (itemId) {
      setIsLoading(true);
      fetchItem(itemId, dispatch)
        .then((result) => {
          setItemDetail(result);
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [itemId]);

  return (
    <>
      {formMode === MdrtStampIconFormMode.CREATE && (
        <MdrtStampIconDetailForm formMode={formMode} onReload={reloadData} onRouteTo={(route) => history.push(route)} />
      )}
      {formMode !== MdrtStampIconFormMode.CREATE &&
        (isLoading || !itemDetail ? (
          <LayoutSplashScreen />
        ) : (
          <MdrtStampIconDetailForm
            itemId={itemId}
            formMode={formMode}
            itemDetail={itemDetail}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        ))}
    </>
  );
};

export default MdrtStampIconDetailPage;
